const DIFFICULTY_MULTIPLIER = {
    easy: 1.0,
    medium: 1.5,
    hard: 2.0,
};
/**
 * Calculates the final score for a completed puzzle.
 *
 * Formula:
 *   base  = 10000 / timeSeconds
 *   penalty = (mistakes × 200) + (hintsUsed × 500)
 *   final = max(0, floor(base × difficultyMultiplier) - penalty)
 */
export function calculateScore(params) {
    const { timeSeconds, hintsUsed, difficulty } = params;
    if (timeSeconds <= 0)
        throw new Error("timeSeconds must be > 0");
    const multiplier = DIFFICULTY_MULTIPLIER[difficulty];
    const baseScore = Math.floor((10000 / timeSeconds) * multiplier);
    const penalty = hintsUsed * 500;
    const score = Math.max(0, baseScore - penalty);
    const breakdown = [
        `Base: ${baseScore.toLocaleString()}`,
        hintsUsed > 0 ? `-${(hintsUsed * 500).toLocaleString()} (${hintsUsed} hint${hintsUsed !== 1 ? "s" : ""})` : null,
    ]
        .filter(Boolean)
        .join("  ·  ");
    return { score, baseScore, penalty, breakdown };
}
/**
 * Formats a time in seconds to a MM:SS display string.
 */
export function formatTime(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
